module.exports = __webpack_public_path__ + "static/media/logo.2961fb81.svg";